<!-- @Version 1.0.1 -->
<ul class="row" data-testid="nav-list">
   @for (item of list; track item; let isLast = $last) {
      <li [setClassUrl]="item.url" [pos]="3">
         <a del="noopener noreferer" (click)="onNavListClick(item.url, item.name,  item.target)" tabindex="0" cdkMonitorSubtreeFocus class="cdk-keyboard-focused-reverse">
            @if (item.icon) {
               <mat-icon style="width: fit-content;">{{item.icon}}</mat-icon>
            }
            <span class="pointer">{{item.name}}</span>
         </a>
      </li>
   }
</ul>
